import { Sparkles } from "lucide-react";
import { useLanguage } from "@/i18n";

const EXAMPLES = [
  { src: "/examples/cover_moonlit.jpeg", title: "The Lantern Forest" },
  { src: "/examples/cover_ocean.jpeg", title: "Deep Blue Friends" },
  { src: "/examples/cover_dino.jpeg", title: "Valley of Giants" },
];

export function CoverShowcase() {
  const { language } = useLanguage();
  return (
    <div className="cover-showcase" data-testid="cover-showcase">
      <div className="cover-showcase-eyebrow">
        <Sparkles size={13} /> {language === "id" ? "Contoh sampul" : "Example covers"}
      </div>
      <div className="cover-showcase-grid">
        {EXAMPLES.map((ex, i) => (
          <figure className="cover-showcase-card" key={ex.src} style={{ "--i": i }} data-testid={`cover-showcase-card-${i}`}>
            <img src={ex.src} alt={ex.title} loading="lazy" />
          </figure>
        ))}
      </div>
      <p className="cover-showcase-caption">
        {language === "id"
          ? "Setiap buku mendapat sampul unik buatan AI dengan judulnya sendiri."
          : "Every book gets a unique AI-painted cover with its own title."}
      </p>
    </div>
  );
}
